import React, { useState, useRef } from 'react';

function BeforeAfterSlider({ beforeImage, afterImage, title }) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef(null);

  const handleMove = (clientX) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    setSliderPosition(percentage);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    handleMove(e.touches[0].clientX);
  };

  const handleDragStart = () => {
    setIsDragging(true);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <div
      ref={containerRef}
      className="relative w-full aspect-[4/3] overflow-hidden rounded-lg shadow-lg cursor-ew-resize select-none"
      onMouseMove={handleMouseMove}
      onMouseUp={handleDragEnd}
      onMouseLeave={handleDragEnd}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleDragEnd}
    >
      {/* After Image (Background) */}
      <div className="absolute inset-0">
        <img
          src={afterImage}
          alt={`${title} after treatment - Tampa Bay pond management`}
          width="800"
          height="600"
          className="w-full h-full object-cover"
          loading="lazy"
          draggable={false}
          fetchPriority="high"
        />
        <div className="absolute top-2 right-2 bg-nature-600 text-white text-xs font-bold px-2 py-1 rounded">
          AFTER
        </div>
      </div>

      {/* Before Image (Clipped) */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${sliderPosition}%` }}
      >
        <img
          src={beforeImage}
          alt={`${title} before treatment - Tampa Bay pond management`}
          width="800"
          height="600"
          className="w-full h-full object-cover"
          style={{ width: containerRef.current ? `${containerRef.current.offsetWidth}px` : '100%' }}
          loading="lazy"
          draggable={false}
        />
        <div className="absolute top-2 left-2 bg-brand-600 text-white text-xs font-bold px-2 py-1 rounded">
          BEFORE
        </div>
      </div>

      {/* Slider Handle */}
      <div
        className="absolute top-0 bottom-0 w-1 bg-white shadow-lg cursor-ew-resize z-10"
        style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
        onMouseDown={handleDragStart}
        onTouchStart={handleDragStart}
      >
        {/* Handle Circle */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center border-2 border-brand-500">
          <svg
            className="w-5 h-5 text-brand-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h8m0 0l-3-3m3 3l-3 3M16 12H8m0 0l3-3m-3 3l3 3"
            />
          </svg>
        </div>
      </div>

      {/* Instructions overlay (shows briefly) */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="bg-black/50 text-white text-sm px-4 py-2 rounded-full opacity-0 hover:opacity-100 transition-opacity">
          Drag to compare
        </div>
      </div>
    </div>
  );
}

export default BeforeAfterSlider;
